import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import { Discount, Discounts } from "../../../../helpers/discount";
import NumberInput from "../../../sharedComponents/numberInput/numberInput";
import { ValidatedValue } from "../../../../helpers/validator";

interface DiscountFieldProps {
  calculateStore?: CalculateStore;
  discountName: Discounts;
  disabled?: boolean;
}

@inject("calculateStore")
@observer
export default class DiscountField extends React.Component<DiscountFieldProps> {
  public render() {
    const renderDropDown = Discount.discountsConfiguration[this.props.discountName].hasOwnProperty("dropDown");

    return (
      <div className={`discount-wrapper ${this.props.discountName}`}>
        <div className="discount-label">
          {Discount.discountsConfiguration[this.props.discountName].label}
        </div>
        {renderDropDown ? this.renderDiscountWithDropDown() : this.renderDiscountWithNumberInput()}
      </div>
    );
  }

  private renderDiscountWithDropDown() {
    const calculateStore = this.props.calculateStore!;
    // @ts-ignore
    const items = Discount.discountsConfiguration[this.props.discountName].dropDown;

    return (
      <DropDown
        disabled={this.props.disabled}
        value={calculateStore.discounts[this.props.discountName].value as string}
        items={items}
        onChange={(newValue: Discounts) => {
          if (calculateStore.discounts[this.props.discountName].value !== newValue) {
            calculateStore.setDiscount(this.props.discountName, newValue);
          }
        }} />
    );
  }

  private renderDiscountWithNumberInput() {
    const calculateStore = this.props.calculateStore!;
    return (
      <div className="number-input-and-unit-container">
        <NumberInput
          disabled={this.props.disabled}
          validatedValue={this.props.discountName === Discounts.otherClaimlessPolicyDiscount ?
            new ValidatedValue<null>(null) :
            calculateStore.discounts[this.props.discountName]
          }
          withZeroValue={true}
          onChange={(newValue: Discounts) => {
            if (calculateStore.discounts[this.props.discountName].value !== newValue) {
              calculateStore.setRequireRecalculate(true);
              calculateStore.setRequireRecalculatePackages();
            }
          }}
        />
        <span className="unit">%</span>
      </div>
    );
  }
}
